/*! @azure/msal-browser v4.27.0 2025-12-04 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "4.27.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
